import React from "react";
import { FC } from "react";
import clsx from "clsx";
import Icon from "@material-ui/core/Icon";
import { FontIconProps } from "./FontIcon";

const FontIcon: FC<FontIconProps> = React.memo(
  ({ name, style, className, ...props }) => {
    return (
      <Icon
        {...props}
        style={{ textAlign: "center", ...style }}
        className={clsx(className, " wedu-icon-" + name)}
      />
    );
  },
);

export default FontIcon;
